<template>
  <div class="teams">
    <h4>Мои команды ({{ teams.length }})</h4>

    <div class="header-menu">
      <button
        type="button"
        class="header-menu__btn"
        @click="openPopup('AddTeam', null)"
      >
        <i class="fas fa-plus"></i>
        Создать команду
      </button>
    </div>

    <ul v-if="teams.length" class="teams__list items-list">
      <li
        v-for="(team) in teams"
        :key="team.id"
        class="teams__item items-list__item"
      >
        <div class="items-list__header">
          <div class="teams__info">
            <div class="teams__name">
              <router-link :to="'/matrius/team/' + team.id">{{
                team.student.name
              }}</router-link>
            </div>
          </div>

          <!-- <div class="header-menu">
            <button
              type="button"
              class="header-menu__btn header-menu__btn--remove"
              @click="
                openPopup('MatriusTeamMove', {
                  team_id: team.id,
                  old_teacher_id: user.id,
                })
              "
            >
              <i class="fas fa-angle-double-right"></i>
              Перенести
            </button>

            <button
              type="button"
              class="header-menu__btn header-menu__btn--remove"
              @click="removeTeam(team.id, index)"
            >
              <i class="fas fa-trash-alt"></i>
              Удалить
            </button>
          </div> -->
        </div>

      </li>
    </ul>

    <Popup :isOpened="popupIsOpened" @close="popupIsOpened = false">
      <template v-slot:content>
        <component
          :is="popupContent"
          :data="popupData"
          :user="user"
          @close-popup="popupIsOpened = false"
          @add-team="addItem(teams, $event)"
          @move-team="deleteItem($event, teams)"
        ></component>
      </template>
    </Popup>
  </div>
</template>

<script>
import { addItem, deleteItem } from "../../../other/methods/list_actions";
import { popup_mix } from "../../../mixins/popup_mix";
import AddTeam from "./AddTeam.vue";
import MatriusTeamMove from "./MatriusTeamMove.vue";
import { getLevelTitle } from "./levels";
export default {
  inject: ["http", "user"],
  mixins: [popup_mix],
  components: { AddTeam, MatriusTeamMove },
  data() {
    return {
      teams: [],
    };
  },
  methods: {
    getLevelTitle,
    addItem,
    deleteItem,
    removeTeam(id, index) {
      swal({
        title: "Внимание!",
        text: `Удалить команду?`,
        icon: "warning",
        buttons: ["Отмена", "Да"],
        dangerMode: true,
      }).then((choise) => {
        if (choise) {
          this.http
            .post("onDeleteTeam", { id })
            .then(() => {
              this.teams.splice(index, 1);
              swal("Успешно!", "Команда удалена", "success");
            })
            .catch((e) => swal("Что-то пошло не так", "" + e, "error"));
        }
      });
    },
  },
  created() {
    this.http
      .post("onGetTeamsByTeacher", { id: this.user.id })
      .then((res) => {
        this.teams = res.data;
        console.log(this.teams)
      })
      .catch((e) => swal("Что-то пошло не так", "" + e, "error"));
  },
};
</script>

<style lang="scss" scoped>
.teams {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.teams__item {
  & img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
}
.teams__info {
  display: flex;
  align-items: center;
}

.teams__name {
  margin-left: 15px;
  display: flex;
  flex-direction: column;

  & span {
    font-size: 14px;
  }
}

.teams__footer {
  margin-top: 20px;
  font-size: 13px;
}

@media (max-width: 640px) {
  .teams__info {
    width: 100%;
    justify-content: center;
  }
}
</style>